import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import CharacterPattern from '../../../domain/entities/CharacterPattern';

export default function reducer(
  state: {[key: number]: CharacterPattern} = {},
  action: AnyAction,
): {[key: number]: CharacterPattern} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexCharacterPatternsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: CharacterPattern},
            record: CharacterPattern,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowCharacterPatternSuccess:
    case Types.CreateCharacterPatternSuccess:
    case Types.UpdateCharacterPatternUsageHistorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
